import { Controller } from "@hotwired/stimulus"

// Toggles visibility between masked and revealed header values.
// Used on sensitive headers (Authorization, API keys, signatures, etc.)
export default class extends Controller {
  static targets = ["masked", "revealed", "icon"]
  static values = { visible: { type: Boolean, default: false } }

  toggle() {
    this.visibleValue = !this.visibleValue
    this.maskedTarget.classList.toggle("hidden", this.visibleValue)
    this.revealedTarget.classList.toggle("hidden", !this.visibleValue)

    // Update icon if present
    if (this.hasIconTarget) {
      this.iconTarget.textContent = this.visibleValue ? "Hide" : "Show"
    }
  }
}
